function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactTable from 'react-table';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import pxToEm from '../../utils/pxToEm';
import uuid from '../../utils/uuid';
import cs from 'classnames';
import './DataTable.css';
import ResponsiveCss from './ResponsiveTable.css.js';
import DynamicCss from '../../DynamicCss/DynamicCss';
import BaseCell, { getTdProps } from '../BaseCell/BaseCell';
import en from './locales/DataTable.en.json';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import EmptyTable from '../EmptyTable/EmptyTable';
import ThComponent, { getTheadThProps } from '../ThCell/ThCell';
import TableGroup, { getTbodyProps } from '../TableGroup/TableGroup';
import TableHead, { getTheadProps } from '../TableHead/TableHead';
import TrComponent from '../TableRow/TableRow';
import TfootComponent, { getTfootProps } from '../Tfoot/Tfoot';
import TableCaption from '../TableCaption/TableCaption';
import { getAdditionalProps } from '../utils';
import ThemeContext from '../../ThemeContext/ThemeContext';
var TfootComponentDefault = TfootComponent;
var ThComponentDefault = ThComponent;
var getTbodyPropsDefault = getTbodyProps;
var getTfootPropsDefault = getTfootProps;
var getTheadThPropsDefault = getTheadThProps;
var getTdPropsDefault = getTdProps;
var DataTable = /*#__PURE__*/function (_React$Component) {
  _inherits(DataTable, _React$Component);
  /**
   * Lifecycle methods (minus render)
   */
  function DataTable(_props) {
    var _this;
    _classCallCheck(this, DataTable);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DataTable).call(this, _props));
    // if you update 1 column property they all get overwritten, so need to assign on top of defaults
    /**
     * Sorting-related methods
     */
    _this.setAscendingState = function (id) {
      _this.setState({
        sorted: [{
          id: id,
          desc: false
        }]
      });
    };
    _this.setDescendingState = function (id) {
      _this.setState({
        sorted: [{
          id: id,
          desc: true
        }]
      });
    };
    _this.setInitialState = function () {
      _this.setState({
        sorted: []
      });
    };
    _this.onSortedChange = function (newSorted, column) {
      // @todo this probably needs to be updated for multisorting
      var sorted = _this.state.sorted[0];
      if (!sorted || sorted && sorted.id !== column.id) {
        _this.setAscendingState(column.id);
      } else if (sorted.desc) {
        _this.setInitialState();
      } else {
        _this.setDescendingState(column.id);
      }
    };
    /**
     * getProps-related methods
     */
    _this.getNoDataProps = function () {
      return {
        i18n: _this.props.emptyTextI18n,
        i18nKey: _this.props.emptyTextI18nKey
      };
    };
    _this.getTrProps = getAdditionalProps('dm-table__row dm-table__row--body auto-table-row-body', function (state, row, column, _ref) {
      var props = _ref.props;
      var id = row.original[props.idAttribute] || '';
      return {
        onHighlight: props.onHighlight,
        shouldHighlight: props.highlights.includes(id),
        dmId: id,
        ref: _this.reffs[row.index]
      };
    });
    _this.defaultColumn = Object.assign({}, ReactTable.defaultProps.column, {
      Header: function Header(_ref2) {
        var column = _ref2.column;
        return column.label;
      },
      Footer: true,
      getFooterProps: getTfootProps
    });

    // set up sorting state, even if it doesn't end up getting used (no third state)
    _this.state = {
      sorted: DataTable.getInitialSort(_props.defaultSorted, _props.defaultSortedDirection)
    };
    _this.messages = normalizeLocaleData(en, '@dm/components.table');
    if (!_props.caption && !_props.captionId) {
      console.warn('You should really provide a caption to `DataTable` component for' + ' accessibility. Use either `caption` or `captionId` props.');
    }
    return _this;
  }
  _createClass(DataTable, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        data = _this$props.data,
        pagination = _this$props.pagination;
      var prevLen = prevProps.data.length;
      var newLen = data.length;
      if (pagination && prevLen && prevLen !== newLen && !this.props.preventRefocus) {
        // paginated, most likely
        var reff = this.reffs[prevLen];
        var toFocus = reff && reff.current;
        toFocus && toFocus.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        nameSpace = _this$props2.nameSpace,
        data = _this$props2.data,
        resolveData = _this$props2.resolveData,
        columns = _this$props2.columns,
        sortType = _this$props2.sortType,
        breakpoint = _this$props2.breakpoint,
        onFetchAllPages = _this$props2.onFetchAllPages,
        onFetchNextPage = _this$props2.onFetchNextPage,
        initialSize = _this$props2.initialSize,
        pageSize = _this$props2.pageSize,
        collectionSize = _this$props2.collectionSize,
        pagination = _this$props2.pagination,
        sticksTo = _this$props2.sticksTo,
        idAttribute = _this$props2.idAttribute,
        caption = _this$props2.caption,
        captionId = _this$props2.captionId,
        _this$props2$getThead = _this$props2.getTheadThProps,
        getTheadThProps = _this$props2$getThead === void 0 ? getTheadThPropsDefault : _this$props2$getThead,
        _this$props2$getTbody = _this$props2.getTbodyProps,
        getTbodyProps = _this$props2$getTbody === void 0 ? getTbodyPropsDefault : _this$props2$getTbody,
        _this$props2$getTfoot = _this$props2.getTfootProps,
        getTfootProps = _this$props2$getTfoot === void 0 ? getTfootPropsDefault : _this$props2$getTfoot,
        _this$props2$getTdPro = _this$props2.getTdProps,
        getTdProps = _this$props2$getTdPro === void 0 ? getTdPropsDefault : _this$props2$getTdPro,
        _this$props2$manual = _this$props2.manual,
        manual = _this$props2$manual === void 0 ? false : _this$props2$manual,
        _this$props2$loading = _this$props2.loading,
        loading = _this$props2$loading === void 0 ? false : _this$props2$loading,
        onFetchData = _this$props2.onFetchData,
        page = _this$props2.page,
        pages = _this$props2.pages,
        onPageChange = _this$props2.onPageChange,
        _this$props2$ThCompon = _this$props2.ThComponent,
        ThComponent = _this$props2$ThCompon === void 0 ? ThComponentDefault : _this$props2$ThCompon,
        _this$props2$TfootCom = _this$props2.TfootComponent,
        TfootComponent = _this$props2$TfootCom === void 0 ? TfootComponentDefault : _this$props2$TfootCom,
        _this$props2$LoadingC = _this$props2.LoadingComponent,
        LoadingComponent = _this$props2$LoadingC === void 0 ? DataTable.LoadingComponent : _this$props2$LoadingC,
        highlights = _this$props2.highlights,
        onHighlight = _this$props2.onHighlight,
        adjustSticky = _this$props2.adjustSticky,
        paginationLabel = _this$props2.paginationLabel,
        _this$props2$dummyRow = _this$props2.dummyRows,
        dummyRows = _this$props2$dummyRow === void 0 ? null : _this$props2$dummyRow;
      this.reffs = this.props.data.map(React.createRef);
      var isToggleSort = sortType === 'toggle';
      var ariaLabelledby = DataTable.getCaptionId(caption, captionId);
      var theme = this.context;
      return /*#__PURE__*/React.createElement(AdditionalIntl, {
        messages: this.messages,
        path: "Table/DataTable/locales/DataTable",
        namespace: "@dm/components.table"
      }, /*#__PURE__*/React.createElement(React.Fragment, null, breakpoint && /*#__PURE__*/React.createElement(DynamicCss, {
        id: "table_bp_".concat(breakpoint),
        query: "(max-width: ".concat(pxToEm(breakpoint), "em)"),
        css: ResponsiveCss
      }), !!caption && /*#__PURE__*/React.createElement(TableCaption, {
        caption: caption,
        captionId: ariaLabelledby
      }), /*#__PURE__*/React.createElement(ReactTable
      // custom
      , {
        highlights: [].concat(highlights),
        onHighlight: onHighlight,
        idAttribute: idAttribute,
        sticksTo: sticksTo,
        adjustSticky: adjustSticky,
        nameSpace: nameSpace,
        captionId: ariaLabelledby
        // custom pagination-related
        ,
        pagination: pagination,
        paginationLabel: paginationLabel,
        onFetchData: onFetchData,
        onFetchNextPage: onFetchNextPage,
        onFetchAllPages: onFetchAllPages,
        initialSize: initialSize,
        customPageSize: pageSize,
        collectionSize: collectionSize
        // options
        ,
        data: dummyRows || data,
        resolveData: resolveData,
        columns: columns,
        column: this.defaultColumn,
        className: cs("".concat(this.props.className || '', " dm-table__grid"), _defineProperty(_defineProperty(_defineProperty({}, "dm-table__grid--".concat(nameSpace), nameSpace), "auto-".concat(nameSpace), nameSpace), "_dm-table--".concat(theme), theme)),
        style: {},
        loading: loading,
        resizable: false,
        manual: manual
        // react-table pagination-related
        ,
        showPagination: false,
        showPageJump: false,
        showPageSizeOptions: false,
        defaultPageSize: 999,
        minRows: 0,
        page: page,
        pages: pages,
        onPageChange: onPageChange
        // sorting-related
        ,
        sortable: true,
        defaultSorted: this.state.sorted,
        sorted: isToggleSort ? undefined : this.state.sorted,
        onSortedChange: isToggleSort ? undefined : this.onSortedChange
        // component-related
        ,
        getTableProps: DataTable.getTableProps,
        LoadingComponent: LoadingComponent,
        TheadComponent: TableHead,
        getTheadProps: getTheadProps,
        TbodyComponent: TableGroup,
        getTbodyProps: getTbodyProps,
        TrGroupComponent: DataTable.TrGroupComponent,
        ThComponent: ThComponent,
        getTheadThProps: getTheadThProps,
        TdComponent: BaseCell,
        getTdProps: getTdProps,
        NoDataComponent: EmptyTable,
        getNoDataProps: this.getNoDataProps,
        TfootComponent: TfootComponent,
        getTfootProps: getTfootProps,
        TrComponent: TrComponent,
        getTrProps: this.getTrProps,
        getTheadTrProps: DataTable.getTheadTrProps
      })));
    }
  }]);
  return DataTable;
}(React.Component);
DataTable.defaultProps = {
  sortType: 'toggle',
  pagination: false,
  emptyTextI18n: {},
  emptyTextI18nKey: '@dm/components.table.empty-table',
  idAttribute: 'id',
  highlights: [],
  onHighlight: function onHighlight() {},
  preventRefocus: false
};
DataTable.contextType = ThemeContext;
/**
 * Statics
 * - simple components
 * - static methods
 * - props helpers
 */
// simple components
DataTable.LoadingComponent = function () {
  return null;
};
DataTable.TrGroupComponent = function (_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
// methods
DataTable.getInitialSort = function (defaultSorted, defaultDirection) {
  if (defaultSorted && defaultDirection !== 'none') {
    return [{
      id: defaultSorted,
      desc: defaultDirection === 'descending'
    }];
  } else {
    return [];
  }
};
// props helpers
DataTable.getTheadTrProps = getAdditionalProps('dm-table__row dm-table__row--header auto-table-row-header');
DataTable.getTableProps = function (state, row, column, _ref4) {
  var props = _ref4.props;
  if (props.captionId) {
    return {
      'aria-labelledby': props.captionId
    };
  } else {
    return {};
  }
};
DataTable.getCaptionId = function (caption, captionId) {
  if (captionId) {
    return captionId;
  } else if (caption) {
    return "table-caption-".concat(uuid());
  } else {
    return null;
  }
};
export { DataTable as default };